import React,{ useEffect, useState } from 'react'
import axios from "axios";
import { nanoid } from "nanoid";
import Header from "../components/header/boardHeader";
import Snackbar from "@mui/material/Snackbar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { makeStyles } from "@material-ui/core/styles";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import Copy from "../components/shareComponent/Copy";
import Mailer from "../components/shareComponent/Mailer";
import CustomButton from "../components/button/button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Input from "../components/input/input";
import MessageDialog from "../components/dialogue/messageDialogue";
import ProfileDetailsBoard from '../components/profileDetails/profileDetailsBorad';
import { Buffer } from "buffer";
import {
    getAllBoards,
    createBoard,
    updateBoard,
    deleteBoard,
    fetchSharedBoardEmails,
  } from "../redux/actions/boardActions";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Widget } from "react-typeform-embed";
import { useNavigate } from "react-router-dom";
import Profile from '../components/profile/profileInBoardNew'
import { useSelector, useDispatch } from "react-redux";
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import form
import { useForm } from "react-hook-form";
// Import supabase configuration
import supabase from "../config/supabase";


/* start of modal styling */
function rand() {
    return Math.round(Math.random() * 20) - 10;
  }
  function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      position: "absolute",
      height: "60%",
      width: "50%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  
    toggleColor: {
      color: "#4285F4",
    },
  }));
  /* End of modal styling */
function BoardDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [urlAvatar, setUrlAvatar] = useState("/avatar.png");
  const [loading, setLoading] = useState(true);  
  const data = useSelector((state) => state.boards);
  const [profiles, setProfiles] = useState([]);
  const [boardObject, setBoardObject] = useState({});
  const [boardId, setBoardId] = useState("");
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [boardName, setBoardName] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [successfullMessage, setSuccessfullMessage] = useState("");
  const [url, setUrl] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [expire, setExpire] = useState(10);
  const [showLoader, setShowLoader] = useState(true);
  const [hideProfile, setHideProfile] = useState(false);
  const [applyTransition, setApplyTransition] = useState(false);
  const [profile, setProfile] = useState([]);
  const [showProfileDetail, setShowProfileDetail] = useState(false);

  const [urlPlaceholder, setUrlPlaceholder] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [showDeleteBoardModal, setshowDeleteBoardModal] = useState(false);
  const [showDeleteProfileModal, setshowDeleteProfileModal] = useState(false);
  const [showShareModal, setshowShareModal] = useState(false);

  const [emailDiv, setemailDiv] = useState(false);
  const [copyDiv, setcopyDiv] = useState(true);
  // Email already exist
  const [emailFromClient, setEmailFromClient] = useState([]);
  const [defaultExpiry, setDefaultExpiry] = useState();
  
  const [checked, setChecked] = React.useState(false);

  const [modalStyle] = React.useState(getModalStyle);
  /* end of modal state */

  //This hook using for form-validation
  const { handleSubmit } = useForm();
  const selectorEmails = useSelector((state) => state.boardsEmail);
  var emails = [];

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 3000);
  }, []);

  useEffect(async () => {
    document.title = "Board";
    window.scrollTo(0, 0);

    dispatch(getAllBoards());
    var url = new URL(window.location.href);
    var boardId = Buffer.from(
      url.searchParams.get("id") || "",
      "base64"
    ).toString("utf-8");

    setBoardId(boardId);
    await getProfiles(boardId)
    .then((res) => {
        setProfile(res[0])
        setShowProfileDetail(true);
        setApplyTransition(true);
    })
  }, []);

  useEffect(()=>{
    if(selectorEmails.length > 0){
      for (var i = 0; i < selectorEmails.length; i++) {
        emails.push({ email: selectorEmails[i].email, expireDate: selectorEmails[i].expireDate, linkSharedAt: selectorEmails[i].link_shared_at, link: selectorEmails[i].url_with_token, masked_url: selectorEmails[i].masked_url });
      }
      remainingDaysForLink(emails);
    }
    else{
      setEmailFromClient([]);
    }
  },[selectorEmails])
  useEffect(() => {
    setTimeout(() => {
      setApplyTransition(false);
      setHideProfile(false);
    }, 401);
  }, [applyTransition]);

  useEffect( () => {
    // boards data
    data.forEach( (b) => {
      if(b.id === boardId){
        setBoardName(b.name);
      }
    })
  },[data])

  const remainingDaysForLink = (emails) => {
    if(emails?.length > 0){
      var newMails = [];
      emails.forEach( (mail) => {
        const expire = mail.expireDate;
        const link_shared_at = new Date(mail.linkSharedAt);

        // Today's date
        const currentDate = new Date();

        var expireDate = new Date();
        expireDate.setDate(link_shared_at.getDate() + expire);

        // To calculate the time difference of two dates
        let Difference_In_Time = expireDate.getTime() - currentDate.getTime();

        // To calculate the no. of days between two dates
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        Difference_In_Days = Difference_In_Days > 0 ? Difference_In_Days : 0;
        mail = { ... mail, remainingDays: Difference_In_Days}
        newMails.push(mail);
      })
      setEmailFromClient(newMails);
    }
  }

  const handleCheckedChange = (event) => {
    setChecked(event.target.checked);
    updateActiveLink(event.target.checked);
  };

  const handleOpen = () => {
    setshowShareModal(true);
    getActiveLink();
    checkEmailExist(boardId);
  };

  const handleClose = () => {
    setshowShareModal(false);
  };

  const getProfiles = async (boardId) => {
    // Get profiles
    var { data, error } = await supabase
      .from("board_profiles")
      .select("*")
      .match({ board: boardId });
    if (data && data.length > 0) {
      setDefaultExpiry(data[0].expireDate);
    }
    if (data && (data.length > 0 ? (data[0].url ? true : false) : false)) {
      setUrl(data[0].masked_url ? data[0].masked_url : data[0].url);
    } else {
      var board_id = Buffer.from(boardId, "utf-8").toString("base64");
      var url = `${window.location.origin}/client?id=${board_id}`;
      setUrl(url);
      insertUrl(url, boardId, data.length <= 0 ? "insert" : "update");
    }

    data.length > 0 && setBoardObject(data[0]);

    var profiles = [];
    if (data && data.length > 0) {
      profiles = data[0]?.profiles?.length > 0
        ? await getProfileDetails(data[0].profiles)
        : [];

      setProfiles(profiles);
    }
    setShowLoader(false);
    setShowMessage(true);
    profiles.length > 0
      ? setSuccessfullMessage("Profiles have been loaded successfully.")
      : setSuccessfullMessage("Please add profiles in board");
    return profiles
  };

  const getProfilesDetails = (e, id) => {
    console.log(e);
    var singleProfile = profiles.filter((index) => index.id == id);
    if(profile == singleProfile[0]){
      // setHideProfile(true);
      // setTimeout( function () {
      //   setShowProfileDetail(!showProfileDetail);
      //   setProfile();
      // }, 400);
    }
    else{
        setProfile(singleProfile[0]);
        setShowProfileDetail(true);
        setApplyTransition(!applyTransition);
    }
  };

  const getProfileDetails = async (ids) => {
    var allIds = [];
    ids.forEach( (id) => {
      allIds.push(id.id);
    })
      const { data, error } = await supabase
      .from("all_profiles")
      .select("*")
      .in('id', allIds);
    if(data && data.length > 0) {
      return data
    } else {
      console.log('no profiles');
    }
  };

  const onChangeDelete = (e, profileId) => {
    e.stopPropagation();
    setSelectedProfileId(profileId);
    setshowDeleteProfileModal(true);
  }

  const deleteProfile = async () => {
    setshowDeleteProfileModal(false);
    setShowLoader(true);
    var board_profiles = boardObject.profiles;

    board_profiles = board_profiles.filter(
      (profile) => profile.id !== selectedProfileId
      );
      
      var { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: board_profiles })
      .match({ board: boardId });
      
     // Get all clients with same board id
     var { data, error } = await supabase
     .from("board_clients_invitation")
     .select("*")
     .match({ board: boardId });
     
     const clients_invitations = data;

     if(clients_invitations && clients_invitations.length > 0){
       for(let i =0; i< clients_invitations.length ;i++){
         let client_profiles = clients_invitations[i].profiles;

         // Update profiles
         client_profiles = client_profiles.filter(
          (profile) => profile.id !== selectedProfileId
        );

         // Update profiles in client table
         const { data, error } = await supabase
         .from("board_clients_invitation")
         .update({ profiles: client_profiles })
         .match({ board: boardId , id : clients_invitations[i].id});
       }
     }
      
      setShowLoader(true);
      await getProfiles(boardId)
      .then( (res) => {
      setProfile(res[0])
    })
    setShowMessage(true);
    getScreenShot();
    setSuccessfullMessage("Profile has been deleted successfully");
  };
  {
    /* getting the default expiry date */
  }

  {
    /* Expires list */
  }
  const checkEmailExist = async (boardId) => {  
    dispatch(fetchSharedBoardEmails(boardId));
  };

  const deleteBoard = async () => {
    setshowDeleteBoardModal(false);
    setShowLoader(true);
    var { data, error } = await supabase
      .from("board_profiles")
      .delete()
      .match({ board: boardId });

    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: boardId });

    if(data && data.length){
      let invitations = data;
      for(var i=0 ; i < invitations.length ; i++){
        const { data, error } = await supabase
        .from("notifications")
        .delete()
        .match({ client: invitations[i].id });
      }
    }

    var { data, error } = await supabase
      .from("board_clients_invitation")
      .delete()
      .match({ board: boardId });

    var { error } = await supabase
      .from("board")
      .delete()
      .match({ id: boardId });

    setShowLoader(false);
    navigate("/board");
    
  };

  const deleteClient = async (email) => {
    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: boardId });

    if(data && data.length){
      let invitations = data;
      for(var i=0 ; i < invitations.length ; i++){
        const { data, error } = await supabase
        .from("notifications")
        .delete()
        .match({ client: invitations[i].id });
      }
    }

    var { data, error } = await supabase
      .from("board_clients_invitation")
      .delete()
      .match({ email: email, board: boardId });

    if (data && data.length) {
      setShowMessage(true);
      setSuccessfullMessage("Client has been removed successfully.");
      checkEmailExist(boardId);
    } else {
      setShowMessage(true);
      setSuccessfullMessage("Please try again.");
    }
  };


  const updateClientExpire = async (newExpire, clientEmail) => {
    const { data, error } = await supabase
      .from("board_clients_invitation")
      .update([{ expireDate: newExpire }])
      .match({ email: clientEmail, board: boardId });

    if (data && data.length) {
      setShowMessage(true);
      checkEmailExist(boardId);
      setSuccessfullMessage("Expire updated successfully.");
    }
  };

  // function for to get the status of active link
  const getActiveLink = async () => {
    const { data, error } = await supabase
      .from("board_profiles")
      .select("activeLink")
      .eq("board", boardId);

    if (data && data[0].activeLink) {
      setChecked(data[0].activeLink);
    }
  };

  // active link ends here

  {
    /* Update the value of activeLink true or false starts here*/
  }

  const updateActiveLink = async (flag) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .update({ activeLink: flag })
      .match({ board: boardId });
    // setChecked(checked);
  };

  {
    /* Update the value of activeLink true or false ends here*/
  }
  const insertUrl = async (url, boardId, check) => {
    if (check == "insert") {
      let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

      const { data, error } = await supabase
        .from("board_profiles")
        .insert([{ url: url, board: boardId, masked_url:masked_url }]);
    } else {
      const { data, error } = await supabase
        .from("board_profiles")
        .update([{ url }])
        .match({ board: boardId });
    }
  };

  {
    /* update expire on change */
  }
  const updateExpire = async (newExpire, clientEmail) => {
    const { data, error } = await supabase
      .from("board_clients_invitation")
      .update([{ expireDate: newExpire }])
      .match({ email: clientEmail, board: boardId });

    if (data && data.length) {
      setShowMessage(true);
      setSuccessfullMessage("Expire updated successfully.");
    }
  };

  {
    /* update default expire chnage*/
  }
  const updateDefaultExpire = async (defaultExpire) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .update([{ expireDate: defaultExpire }])
      .match({ board: boardId });

    if (data && data.length) {
      setDefaultExpiry(defaultExpire);
      setShowMessage(true);
      setSuccessfullMessage("Expire updated successfully.");
    }
  };

  const insertNotification = async (userEmail, c_url) => {
    var { data, error } = await supabase
      .from("board_clients_invitation")
      .select("*")
      .match({ email: userEmail, board: boardId });

    if (data && data.length) {
      // Set states
      setShowMessage(true);
      setSuccessfullMessage("Board is already shared with this client.");
    } 
    else {
      var profiles = boardObject.profiles;
      for (var i = 0; i < profiles.length; i++) {
        profiles[i].status = "New";
        profiles[i].message = "";
        profiles[i].meetingTime = "";
        profiles[i].endMeetingTime = "";
      }

      var dashboard_id = "";
        // Check if already any board is shared with this email
        var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: userEmail});
  
        if(data && data.length){
          dashboard_id = data[0].dashboard_id;
        }

        let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

        var { data, error } = await supabase
        .from("board_clients_invitation")
        .insert([
          {
            email: userEmail,
            expireDate: expire || 10,
            profiles: profiles,
            board: boardObject.board,
            url_with_token: c_url,
            dashboard_id: dashboard_id ? dashboard_id : nanoid(),
            masked_url:masked_url,
          },
        ]);

        if(data && data.length > 0){
          setShowMessage(true);
          setSuccessfullMessage("Board is shared successfully.");
        }
        else{
          setShowMessage(true);
          setSuccessfullMessage("please try again.");
        }
    }
  };

  const createUrl = () => {
    var Id = nanoid();
    var board_id = Buffer.from(boardId, "utf-8").toString("base64");

    var newId = board_id.concat("/", Id);
    var str = `${window.location.origin}/client?id=`;
    var newUrl = str.concat(newId);

    return newUrl;
  };

  const editBoard = () => {
    setshowModal(false);
    var selected_board = {
      name: boardName,
      id: boardId,
    };
    dispatch(updateBoard(selected_board));
    setShowMessage(true);
    setSuccessfullMessage("Board has been updated successfully");
    localStorage.setItem("board", boardName);
  };

  const getScreenShot =  () => {
    var id = Buffer.from(boardId,
      "utf-8"
    ).toString("base64");

   axios
   .get(`https://shot.screenshotapi.net/screenshot?token=0N3VBYJ-J1AMZ8Z-G7WK6GE-CC77E9K&url=https://ats-search.netlify.app/sharedProfiles?id=${id}&width=1040&height=750&delay=5000`)
   .then( async(response) => {  
    const Image = response.data.screenshot;
    // setScreenShotImage(Image);
    const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles_screenshot: Image })
        .match({ board: boardId });


   })
   .catch(function (error) {
     console.log("error in taking screenshot", error);
   });
  };

  async function sendEmailNotification(message) {
    //Setting email template params
    var templateParams = {
      message: message,
      email: "no-reply@gaper.io",
      subject: "New Board Invitation",
      to: userEmail,
    };

    //Sending email
    axios
      .post(
        // "http://localhost:5000/sendEmail",
        "https://gaper-email-service.herokuapp.com/sendEmail",
        templateParams,
        {
          headers: { key: "1eb2cy567keyoipaex-assqwe12" },
        }
      )
      .then(function (response) {})
      .catch(function (error) {});
  }

  const sendInvitation = async() => {
    var c_url = createUrl();
    await insertNotification(userEmail, c_url);
    await checkEmailExist(boardId);

    let clientName = userEmail.split('@')[0]
    setUserEmail("");
    const { data, error } = await supabase
      .from("board_profiles")
      .select("profiles_screenshot")
      .match({ board: boardId });
    // handleClose();
    if(data && data.length > 0){
      sendEmailNotification(`<div>
      <div style="padding-top:25px">
          <img src="https://yourimageshare.com/ib/ImZrKL2FsS.png" alt="GaperLogo here" height="10%" width="20%" />
      </div>
      <div style="padding:15px 50px">
      <p style=" font-size: 17px;  font-family: 'Poppins', sans-serif; margin: 0px;">Hi ${clientName},</p>
      <p style=" font-size: 16px; font-family: 'Poppins', sans-serif; margin: 0px; padding-top: 3px;">We have customised a team of engineer specific for you.</p>
      <div style="margin-top:20px; font-family: 'Poppins', sans-serif; text-align: center;  position:relative;">
          <div style="padding:40px 0px; border:0.9px solid #C8C8C8; border-radius:10px;">
          <a href='${c_url}'>
          <img src="${data[0].profiles_screenshot}" height="40%" width="90%" alt="ScreenShot Image here" /> </a>
          </div>
          <br />
          <div style="text-align: center;">
          <a href='${c_url}'>
            <button style="background-color: #0C60FF; color:#fff; height:42px; width:170px; border-radius: 4px; border: none; font-size: 18px; font-family: 'Inter', sans-serif; text-align: center;">View list</button>
          </a>
          </div>
          <p style="font-family: 'Poppins', sans-serif; font-size: 16px; color:black;">This list is valid for 10 days, Hope to see you soon.</p>
      </div>
      </div>
      </div>`);
    }
  };

  const editRate = async(value,profileId) =>{
    let profiles = boardObject.profiles;
    let previousRate = profiles.find(p => p.id == profileId).rate
    profiles.find(p => p.id == profileId).rate = parseInt(value);

    if(previousRate !== parseInt(value)){
      const { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: profiles })
      .match({ board: boardId });
    }
   
  } 

  const handlePaymentFrequency = async(value,profileId) =>{
    let profiles = boardObject.profiles;
    let previousPaymentFrequency = profiles.find(p => p.id == profileId).paymentFrequency
    profiles.find(p => p.id == profileId).paymentFrequency = value.value;
    if(previousPaymentFrequency !== value.value){
      const { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: profiles })
      .match({ board: boardId });
      
      if(data && data.length) {
        console.log(data)
      } else {
        console.log(error)
      }
    }
   
  } 
  function getRandomColor() {
    var letters = 'BCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
  }

  const toAddNewCandidate = () => {
    navigate(`/`)
  }

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowMessage(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div className="w-full min-h-screen h-auto">
      <div className="sticky top-0 z-50">
        <Header current="home" boardName={boardName} />
      </div>       

      {/* Notification */}
      {
        <Snackbar
          open={showMessage}
          onClose={() => setShowMessage(false)}
          autoHideDuration={2000}
          message={successfullMessage}
          action={action}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
      }
      {/* Message dialogue on board's edit button click start here */}
      <MessageDialog
        title="Update Board"
        onClick={() => {
          setshowModal(false);
        }}
        show={showModal}
      >
        <form onSubmit={handleSubmit(editBoard)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Message */}
              <div className={`col-span-12`}>
                {/* Add message */}
                <Input
                  name="board"
                  value={boardName}
                  placeholder="Enter board name"
                  onInputChange={(e) => {
                    setBoardName(e);
                  }}
                />
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
                 <CustomButton
                  type="submit"
                  value="Update"
                  buttonType="secondary-2"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>
      {/* Edit board dialogue button ends here */}

     {/* Share baord modal starts here */}
      {showShareModal ? (
        <>
          <div className={`justify-center w-auto items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none `}>
            <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>

            <div className="relative my-6 mx-auto max-w-3xl w-5/6 sm:w-3/5 md:w-1/2 lg:w-2/5">
              {/*content*/}
              <div className="border-0 rounded-lg relative flex flex-col w-full bg-white-1 outline-none focus:outline-none scrollbar" >
                {/*header*/}
                <div
                  onClick={() => {
                    setemailDiv(false);
                    setcopyDiv(true);
                  }}
                  className="flex items-start justify-between p-8 rounded-t -mt-4"
                >
                  <div className="-ml-3 -mb-8 flex items-center">
                  <div className={`bg-blue-1 rounded-full p-1 mx-1 inline-block ${emailDiv? "hidden":""}`}>
                        {/* <<PersonAddAltRoundedIcon className="text-white-1" />> */}
                        <img src="/addPerson.svg" style={{width: 24, height: 24}} />
                      </div>
                    <h3 className="text-lg font-semibold my-1 inline-block ">
                      Share board with people
                    </h3>
                  </div>
                  <button
                    className="p-1 -px-6 ml-auto bg-transparent border-0 text-blue-1  float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setshowShareModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {emailDiv ? (
                  <div className="select-none px-8 -mt-2">
                  {emailFromClient.length ? (
                    <div>
                      <div className="flex items-center -ml-3">
                      <div className={`bg-blue-1 rounded-full p-1 mx-1 inline-block`}>
                        {/* <<PersonAddAltRoundedIcon className="text-white-1" />> */}
                         <img src="/addPerson.svg" style={{width: 24, height: 24}} />
                      </div>
                      <div className="font-semibold">Shared with: </div>
                      </div>
                      <div className="scrollbar" style={{overflowY: "auto", maxHeight: "200px"}}>
                      {emailFromClient.map((client, index) => {
                        return (
                          <div key={index} className={`w-fit inline-block text-sm rounded-full m-2 p-2`} style={{backgroundColor: getRandomColor()}}>
                            <span className="opacity-100">{client.email}</span>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  ) : (
                    <div>No one has been added yet</div>
                  )}
                </div>
                ) : null}

                {/*body*/}
                <div
                  className={`relative py-4 px-3 flex-auto ${
                    emailDiv ? "hidden" : ""
                  }`}
                >
                  <div className="-mt-8 ml-2">
                    <Mailer
                      userEmail={userEmail}
                      getChange={(data) => {
                        setUserEmail(data);
                      }}
                      emailFromClient={emailFromClient}
                      setshowShareModal={setshowShareModal}
                      sendInvitation={sendInvitation}
                      deleteClient={deleteClient}
                      updateClientExpire={updateClientExpire}
                    />
                  </div>
                </div>
                {/*Copy*/}
                <div className="-mt-6">
                  <div
                    onClick={() => {
                      setemailDiv(true);
                      setcopyDiv(false);
                    }}
                    className="flex items-start justify-between p-8 rounded-t"
                  >
                    <div className="-ml-3 ">
                      <div className="bg-blue-1 rounded-full p-1 mx-1 inline-block">
                        <LinkRoundedIcon className="text-white-1" />
                      </div>
                      <h3 className="text-lg font-semibold my-1 inline-block ">
                        Copy Link
                      </h3>
                    </div>
                    <button
                      disabled
                      className="p-1 ml-auto bg-transparent border-0 text-blue-1  float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setshowShareModal(false)}
                    >
                      <span className="bg-transparent text-black opacity-0 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>
                  {copyDiv ? (
                    <div className="select-none text-sm px-8 mb-4 -mt-4 ...">
                      Anyone on the internet with this link can view
                    </div>
                  ) : null}
                  {/*Copy body*/}
                  <div
                    className={`relative flex-auto ${copyDiv ? "hidden" : ""}`}
                  >
                    <div className="-mt-6">
                      <Copy
                        url={url}
                        urlPlaceholder={urlPlaceholder}
                        checked={checked}
                        handleCheckedChange={handleCheckedChange}
                        handleClose={handleClose}
                        updateDefaultExpire={updateDefaultExpire}
                        defaultExpiry={defaultExpiry}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      {/* share modal ends here */}

      {/* Message dialogue on board's delete button click start here */}
      <MessageDialog
        title="Delete Board"
        onClick={() => {
          setshowDeleteBoardModal(false);
        }}
        show={showDeleteBoardModal}
      >
        <form className="" onSubmit={handleSubmit(deleteBoard)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Show message */}
              <div className="col-span-12 ">
                Are you sure you want to delete this board?
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowDeleteBoardModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
                <CustomButton
                  type="submit"
                  value="Delete"
                  buttonType="secondary-2"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>
      {/* Delete board dialogue button ends here */}    

      {/* Message dialogue on profile's delete button click start here */}
      <MessageDialog
        title="Delete Profile"
        onClick={() => {
          setshowDeleteProfileModal(false);
        }}
        show={showDeleteProfileModal}
      >
        <form className="" onSubmit={handleSubmit(deleteProfile)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Show message */}
              <div className="col-span-12 ">
                Are you sure you want to delete this profile?
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowDeleteProfileModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
                <CustomButton
                  type="submit"
                  value="Delete"
                  buttonType="secondary-2"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>
      {/* Delete board dialogue button ends here */}            

      {/* Add div */}
      <div className="bg-[#F1F2F5] col-span-12 grid grid-cols-12 gap-0 h-full">
        {/* Show typeform signup page */}
        <div className="col-span-6 sticky top-0 overflow-y-scroll scrollbar h-screen">
        <div className='col-span-12 px-10 pb-2 mt-6 flex justify-between'>
            <div className='col-span-6'>
            <div>
          <Stack spacing={2}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Typography variant="h6">
                <span
                  onClick={() => navigate("/")}
                  className="font-medium text-black-1 hover:underline cursor-pointer hover:text-blue-1"
                >
                  Home
                </span>
              </Typography>
              <Typography variant="h6">
                <span
                  onClick={() => navigate("/board")}
                  className="font-medium text-black-1 hover:underline cursor-pointer hover:text-blue-1"
                >
                  Board
                </span>
              </Typography>
              <Typography variant="h6">
                <span className='font-bold text-black-1'>{boardName}</span>
              </Typography>
            </Breadcrumbs>
          </Stack>
        </div>
            </div>
            <div className='col-span-6 flex'>

                <div className="bg-white-1 rounded-full p-1 mx-1 h-10 w-10 flex items-center justify-center hover:cursor-pointer" onClick={() => setshowModal(true)}>
                      <div className="text-black-1 font-medium" fontSize="small">T</div>
                 </div>
                <div className="bg-white-1 rounded-full p-1 mx-1 h-10 w-10 flex items-center justify-center hover:cursor-pointer" onClick={() => setshowDeleteBoardModal(true)}>
                      <DeleteOutlineRoundedIcon className="text-black-1" fontSize="small" />
                 </div>
                  <div className="bg-blue-1 rounded-full p-1 mx-1 h-10 w-10 flex items-center justify-center hover:cursor-pointer" onClick={handleOpen}>
                      {/* <PersonAddAltRoundedIcon className="text-white-1" fontSize="small" /> */}
                      <img src="/addPerson.svg" style={{width: 24, height: 24}} />
                 </div>
            </div>
        </div>
        <div className="col-span-12 px-6 pb-10 h-full">
              {showLoader ? (
                  [...Array(3)].map((e , index) => (
                  <div className="-z-10 rounded bg-white-1 shadow-clientCard h-50 grid grid-cols-12 gap-3 p-4 box-border mx-4 my-5" key={index}>
                    <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex mt-5 relative">
                    <Skeleton height={90} width={90} />
                    </div>
                    <div  className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3 pl-5">
                      {/*For name and email */}
                      <div className="col-span-12">
                        <Skeleton height={23} width={150} />
                      </div>
                      {/* For location */}
                      <div className="col-span-12 lg:col-span-5">
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For timezone */}
                      <div className="col-span-12 lg:col-span-4">
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For experience */}
                      <div className="col-span-12 lg:col-span-5">
                        {/* experience label */}
                        <div className=" flex items-center">
                          <Skeleton height={18} width={92} className="mr-1" />
                        </div>
                        {/* experience */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For hourly rate */}
                      <div className="col-span-12 lg:col-span-4">
                        {/* hourlyRate label */}
                        <div className="flex items-center">
                          <Skeleton height={18} width={92} className="mr-1" />
                        </div>
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:block col-span-2"></div>
                    {/* For Skills */}
                    <div className="col-span-4 ml-5">
                        <Skeleton height={23} width={100} />
                    </div>
                    <div className="col-span-5 ml-5">
                        <Skeleton height={23} width={100} />
                    </div>
                  </div>
                  ))
                ):
              (profiles && profiles.length > 0) &&
                profiles.map((prof, index) => (
                    <div key={index} className={`col-span-12 md:col-span-3 pb-7 ${index == 0 && "pt-5"}`}>
                  
                      <Profile
                        profile={prof} onChangeDelete={(e, id) => onChangeDelete(e, id)} currentProfile={profile} getId = { (e, id) => getProfilesDetails(e, id)} urlAvatar={urlAvatar} boardProfiles={boardObject?.profiles} editClientRate={editRate} selectPaymentFrequency = {handlePaymentFrequency}
                        />
                    </div>
                ))}
            </div>
        </div>

        {/* Show text */}
        {
          showLoader ? (
            <Skeleton height={600} width={800} />
          ):(
            (!profiles?.length >0) ? (
          <div className="col-span-6 bg-blue-7 h-screen relative">
          <div className="flex flex-col items-center justify-center h-screen">
            <div className="absolute -left-8 mb-36">
              <img src="/arrow.png" />
            </div>
            {/* Show arrow */}
            <div className="text-5xl font-bold 2xl:text-6xl">
              Feels lonely in
              <div className="text-5xl font-bold mt-2 2xl:text-6xl">
                here. Add some 
              </div>
              <div className="text-5xl font-bold mt-2 2xl:text-6xl">candidates</div>
              <span className={`text-pink-1 text-lg 2xl:text-xl flex mt-2 hover:cursor-pointer ${!loading ? 'cursor-pointer' : ''}`} onClick={toAddNewCandidate}>
                    Start adding candidates{" "}
                    <svg
                      className="ml-3 mt-0.5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
                        fill="rgba(255,73,116,1)"
                      />
                    </svg>
                  </span>
            </div>
            </div>
            </div>
          ):(                
              (!showProfileDetail) ?(
                  <div className="col-span-6 bg-blue-7 h-screen relative">
            <div className="flex flex-col items-center justify-center h-screen">
              <div className="absolute -left-8 mb-36">
                <img src="/arrow.png" />
              </div>
              {/* Show arrow */}
              <div className="text-5xl font-bold 2xl:text-3xl">
                  Select Enigneer
              <div className="text-3xl font-bold mt-4 2xl:text-8xl">
                    to view profile 
              <br />
            </div>
              <span className={`text-pink-1 text-lg flex mt-2 hover:cursor-pointer ${!loading ? 'cursor-pointer' : ''}`}onClick={()=>navigate('/')}>
              Start adding candidates{" "}
              <svg
                className="ml-3 mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
                  fill="rgba(255,73,116,1)"
                />
              </svg>
            </span>
      </div>
            </div>
          </div>
              ):(profile?.full_name?.length && 
                <ProfileDetailsBoard applyTransition={applyTransition} hideProfile={hideProfile}  profile={profile}  />
              )
            )
        
          )
          }
        
      </div>
    
  </div>
  )
}

export default BoardDetails;